export default "__VITE_ASSET__Bz2GI8Bx__"